// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Sort bar — visible only on mobile ──────────────────────────────────── */

.hotlap-sort-bar {
  display: none;
  align-items: center;
  gap: 8px;
  padding: 0 0 8px;
}

.hotlap-sort-label {
  font-size: 12px;
  color: var(--muted, #94a3b8);
  white-space: nowrap;
}

.hotlap-sort-select {
  flex: 1 1;
  width: auto;
  border: 1px solid var(--border, #334155);
  border-radius: 6px;
  padding: 5px 8px;
  background: var(--surface, #0f172a);
  color: var(--text, #e2e8f0);
  font-size: 12px;
}

/* ─── Driver link button ─────────────────────────────────────────────────── */

.hotlap-driver-btn {
  background: none;
  border: none;
  padding: 0;
  color: var(--secondary-color, #4f46e5);
  cursor: pointer;
  font: inherit;
  text-align: left;
}

/* ─── Mobile layout ──────────────────────────────────────────────────────── */

@media (max-width: 768px) {
  .hotlap-sort-bar {
    display: flex;
  }

  .table-wrapper .hotlap-table thead {
    display: none;
  }

  .table-wrapper .hotlap-table,
  .table-wrapper .hotlap-table tbody {
    display: block;
    width: 100%;
  }

  /*
   * Six columns: track, driver, car, bestLap, date, session
   * Layout — compact two-line strip:
   *
   *   [driver name]       [best lap]
   *   [track · car]       [date]
   *
   * td 1 (track)    → col 1, row 2
   * td 2 (driver)   → col 1, row 1
   * td 3 (car)      → col 2, row 2
   * td 4 (best lap) → col 2, row 1
   * td 5 (date)     → row 3, right (compact)
   * td 6 (session)  → hidden
   */
  .table-wrapper .hotlap-table tr {
    display: grid;
    grid-template-columns: 1fr auto;
    grid-template-rows: auto auto auto;
    column-gap: 8px;
    row-gap: 0;
    padding: 7px 10px;
    border: none;
    border-bottom: 1px solid #1e293b;
    background: transparent;
    margin: 0;
    border-radius: 0;
    align-items: start;
    cursor: pointer;
  }

  .table-wrapper .hotlap-table tbody tr:first-child {
    border-top: 1px solid #1e293b;
  }

  .table-wrapper .hotlap-table td {
    padding: 0;
    border: none;
    font-size: 13px;
    line-height: 1.4;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
  }

  /* Track — row 2, col 1 */
  .table-wrapper .hotlap-table td:nth-child(1) {
    grid-column: 1;
    grid-row: 2;
    font-size: 11px;
    color: #64748b;
    padding-top: 1px;
  }

  .table-wrapper .hotlap-table td:nth-child(1) span {
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
  }

  /* Driver — row 1, col 1 */
  .table-wrapper .hotlap-table td:nth-child(2) {
    grid-column: 1;
    grid-row: 1;
    font-weight: 600;
    font-size: 13px;
    color: #f1f5f9;
    overflow: hidden;
  }

  .table-wrapper .hotlap-table td:nth-child(2) .hotlap-driver-btn,
  .table-wrapper .hotlap-table td:nth-child(2) span {
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;
  }

  /* Car — row 2, col 2 */
  .table-wrapper .hotlap-table td:nth-child(3) {
    grid-column: 2;
    grid-row: 2;
    text-align: right;
    font-size: 11px;
    color: #64748b;
    white-space: nowrap;
    padding-top: 1px;
  }

  /* Best lap — row 1, col 2 */
  .table-wrapper .hotlap-table td:nth-child(4) {
    grid-column: 2;
    grid-row: 1;
    text-align: right;
    font-family: 'Courier New', monospace;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    padding-top: 1px;
  }

  /* Date — row 3, right-aligned, very small */
  .table-wrapper .hotlap-table td:nth-child(5) {
    grid-column: 1 / 3;
    grid-row: 3;
    text-align: right;
    font-size: 10px;
    color: #475569;
    padding-top: 2px;
    white-space: nowrap;
    overflow: visible;
  }

  /* Session — hidden */
  .table-wrapper .hotlap-table td:nth-child(6) {
    display: none;
  }
}

/* ─── Light theme ────────────────────────────────────────────────────────── */

body.light-theme .table-wrapper .hotlap-table tr {
  border-bottom-color: var(--border);
}

body.light-theme .table-wrapper .hotlap-table tbody tr:first-child {
  border-top-color: var(--border);
}

body.light-theme .table-wrapper .hotlap-table td:nth-child(2) {
  color: var(--text);
}

body.light-theme .table-wrapper .hotlap-table td:nth-child(1),
body.light-theme .table-wrapper .hotlap-table td:nth-child(3) {
  color: var(--muted);
}

body.light-theme .table-wrapper .hotlap-table td:nth-child(5) {
  color: var(--muted);
}
`, "",{"version":3,"sources":["webpack://./src/pages/HotlapPage.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,2BAA2B;EAC3B,eAAe;AACjB;;AAEA,+EAA+E;;AAE/E;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,sCAAsC;EACtC,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;;AAEA,+EAA+E;;AAE/E;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,cAAc;IACd,WAAW;EACb;;EAEA;;;;;;;;;;;;;IAaE;EACF;IACE,aAAa;IACb,+BAA+B;IAC/B,kCAAkC;IAClC,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,YAAY;IACZ,gCAAgC;IAChC,uBAAuB;IACvB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,YAAY;EACd;;EAEA,yBAAyB;EACzB;IACE,cAAc;IACd,WAAW;IACX,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;EAChB;;EAEA,0BAA0B;EAC1B;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,eAAe;EACjB;;EAEA,uBAAuB;EACvB;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,4BAA4B;EAC5B;IACE,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA,4CAA4C;EAC5C;IACE,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA,qBAAqB;EACrB;IACE,aAAa;EACf;AACF;;AAEA,+EAA+E;;AAE/E;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ─── Sort bar — visible only on mobile ──────────────────────────────────── */\r\n\r\n.hotlap-sort-bar {\r\n  display: none;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 0 0 8px;\r\n}\r\n\r\n.hotlap-sort-label {\r\n  font-size: 12px;\r\n  color: var(--muted, #94a3b8);\r\n  white-space: nowrap;\r\n}\r\n\r\n.hotlap-sort-select {\r\n  flex: 1;\r\n  width: auto;\r\n  border: 1px solid var(--border, #334155);\r\n  border-radius: 6px;\r\n  padding: 5px 8px;\r\n  background: var(--surface, #0f172a);\r\n  color: var(--text, #e2e8f0);\r\n  font-size: 12px;\r\n}\r\n\r\n/* ─── Driver link button ─────────────────────────────────────────────────── */\r\n\r\n.hotlap-driver-btn {\r\n  background: none;\r\n  border: none;\r\n  padding: 0;\r\n  color: var(--secondary-color, #4f46e5);\r\n  cursor: pointer;\r\n  font: inherit;\r\n  text-align: left;\r\n}\r\n\r\n/* ─── Mobile layout ──────────────────────────────────────────────────────── */\r\n\r\n@media (max-width: 768px) {\r\n  .hotlap-sort-bar {\r\n    display: flex;\r\n  }\r\n\r\n  .table-wrapper .hotlap-table thead {\r\n    display: none;\r\n  }\r\n\r\n  .table-wrapper .hotlap-table,\r\n  .table-wrapper .hotlap-table tbody {\r\n    display: block;\r\n    width: 100%;\r\n  }\r\n\r\n  /*\r\n   * Six columns: track, driver, car, bestLap, date, session\r\n   * Layout — compact two-line strip:\r\n   *\r\n   *   [driver name]       [best lap]\r\n   *   [track · car]       [date]\r\n   *\r\n   * td 1 (track)    → col 1, row 2\r\n   * td 2 (driver)   → col 1, row 1\r\n   * td 3 (car)      → col 2, row 2\r\n   * td 4 (best lap) → col 2, row 1\r\n   * td 5 (date)     → row 3, right (compact)\r\n   * td 6 (session)  → hidden\r\n   */\r\n  .table-wrapper .hotlap-table tr {\r\n    display: grid;\r\n    grid-template-columns: 1fr auto;\r\n    grid-template-rows: auto auto auto;\r\n    column-gap: 8px;\r\n    row-gap: 0;\r\n    padding: 7px 10px;\r\n    border: none;\r\n    border-bottom: 1px solid #1e293b;\r\n    background: transparent;\r\n    margin: 0;\r\n    border-radius: 0;\r\n    align-items: start;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .table-wrapper .hotlap-table tbody tr:first-child {\r\n    border-top: 1px solid #1e293b;\r\n  }\r\n\r\n  .table-wrapper .hotlap-table td {\r\n    padding: 0;\r\n    border: none;\r\n    font-size: 13px;\r\n    line-height: 1.4;\r\n    display: block;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    min-width: 0;\r\n  }\r\n\r\n  /* Track — row 2, col 1 */\r\n  .table-wrapper .hotlap-table td:nth-child(1) {\r\n    grid-column: 1;\r\n    grid-row: 2;\r\n    font-size: 11px;\r\n    color: #64748b;\r\n    padding-top: 1px;\r\n  }\r\n\r\n  .table-wrapper .hotlap-table td:nth-child(1) span {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: block;\r\n  }\r\n\r\n  /* Driver — row 1, col 1 */\r\n  .table-wrapper .hotlap-table td:nth-child(2) {\r\n    grid-column: 1;\r\n    grid-row: 1;\r\n    font-weight: 600;\r\n    font-size: 13px;\r\n    color: #f1f5f9;\r\n    overflow: hidden;\r\n  }\r\n\r\n  .table-wrapper .hotlap-table td:nth-child(2) .hotlap-driver-btn,\r\n  .table-wrapper .hotlap-table td:nth-child(2) span {\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    display: block;\r\n    max-width: 100%;\r\n  }\r\n\r\n  /* Car — row 2, col 2 */\r\n  .table-wrapper .hotlap-table td:nth-child(3) {\r\n    grid-column: 2;\r\n    grid-row: 2;\r\n    text-align: right;\r\n    font-size: 11px;\r\n    color: #64748b;\r\n    white-space: nowrap;\r\n    padding-top: 1px;\r\n  }\r\n\r\n  /* Best lap — row 1, col 2 */\r\n  .table-wrapper .hotlap-table td:nth-child(4) {\r\n    grid-column: 2;\r\n    grid-row: 1;\r\n    text-align: right;\r\n    font-family: 'Courier New', monospace;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    padding-top: 1px;\r\n  }\r\n\r\n  /* Date — row 3, right-aligned, very small */\r\n  .table-wrapper .hotlap-table td:nth-child(5) {\r\n    grid-column: 1 / 3;\r\n    grid-row: 3;\r\n    text-align: right;\r\n    font-size: 10px;\r\n    color: #475569;\r\n    padding-top: 2px;\r\n    white-space: nowrap;\r\n    overflow: visible;\r\n  }\r\n\r\n  /* Session — hidden */\r\n  .table-wrapper .hotlap-table td:nth-child(6) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n/* ─── Light theme ────────────────────────────────────────────────────────── */\r\n\r\nbody.light-theme .table-wrapper .hotlap-table tr {\r\n  border-bottom-color: var(--border);\r\n}\r\n\r\nbody.light-theme .table-wrapper .hotlap-table tbody tr:first-child {\r\n  border-top-color: var(--border);\r\n}\r\n\r\nbody.light-theme .table-wrapper .hotlap-table td:nth-child(2) {\r\n  color: var(--text);\r\n}\r\n\r\nbody.light-theme .table-wrapper .hotlap-table td:nth-child(1),\r\nbody.light-theme .table-wrapper .hotlap-table td:nth-child(3) {\r\n  color: var(--muted);\r\n}\r\n\r\nbody.light-theme .table-wrapper .hotlap-table td:nth-child(5) {\r\n  color: var(--muted);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
